import { render, staticRenderFns } from "./SettingsRolesRow.vue?vue&type=template&id=340de1b8"
import script from "./SettingsRolesRow.vue?vue&type=script&lang=ts"
export * from "./SettingsRolesRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports